export default function Loading() {
  return (
    <div className="min-h-screen bg-ab-deep flex flex-col items-center justify-center gap-6">
      {/* Atmospheric orbs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute w-64 h-64 rounded-full blur-3xl opacity-10 animate-float"
             style={{ background: '#FF4800', top: '20%', left: '15%' }} />
        <div className="flex items-center gap-3">
          <div className="w-5 h-5 rounded-full border-2 border-[#3A3A5A] border-t-[#00F0FF] animate-spin"
               style={{ boxShadow: '0 0 8px rgba(0,240,255,0.3)' }} />
          <span className="font-bold text-sm text-[#8A8AA5] uppercase tracking-wider" style={{ fontFamily: 'Space Mono, monospace' }}>Initializing...</span>
        </div>
        <div className="absolute w-48 h-48 rounded-full blur-3xl opacity-8"
             style={{ background: '#00F0FF', top: '30%', right: '20%', animationDelay: '2s' }} />
      </div>

      {/* Logo */}
      <div className="relative z-10 text-center">
        <p className="font-bold text-xl text-[#EAF6FF] uppercase tracking-tight" style={{ fontFamily: 'Rajdhani, system-ui' }}>ATLAS BEASTS</p>
        <p className="text-[10px] text-[#5A5A7A] uppercase tracking-wider" style={{ fontFamily: 'Space Mono, monospace' }}>Loading assets...</p>
      </div>

      {/* Loading bar */}
      <div className="relative z-10 w-48 h-0.5 bg-white bg-opacity-10 rounded-full overflow-hidden">
        <div className="absolute inset-y-0 left-0 w-full bg-ab-gold rounded-full"
             style={{
               animation: 'loadingBar 1.5s ease-in-out infinite',
             }} />
      </div>

      <style>{`
        @keyframes loadingBar {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  )
}
